export enum EdgeDistanceToggleType {
  PositiveY = 'positive_y',
  NegativeY = 'negative_y',
  PositiveX = 'positive_x',
  NegativeX = 'negative_x',
  Thickness = 'thickness',
}
